"use client";

import { useCallback } from "react";
import { useLocale, useTranslations } from "next-intl";
import { BuyTokensWidget } from "@owlcat/app-shell";
import { APP_ID } from "@/lib/appConfig";

/**
 * The games top-up dialog — the shared <BuyTokensWidget> bound to this app's
 * allowance pool and speaking in CONTENT, not tokens: every pack card is titled
 * "N photo mazes" (pack tokens ÷ the admin-set image-maze price). Mounted once in
 * the locale layout (inside NextIntlClientProvider); opened via
 * openBuyTokens("games") from the maze image panel. On a landed purchase the
 * widget fires owlcat:purchase-complete → useMazeImageQuota re-reads.
 */
export function GamesTopUpWidget({
  accountsUrl,
  stripePublishableKey,
  imagePriceTokens,
}: {
  accountsUrl: string;
  stripePublishableKey?: string;
  /** Live admin-set price of one photo maze, in allowance tokens. */
  imagePriceTokens: number;
}) {
  const t = useTranslations("games.maze");
  const locale = useLocale();
  const describeTokens = useCallback(
    (tokens: number) => t("packMazes", { count: Math.floor(tokens / Math.max(1, imagePriceTokens)) }),
    [t, imagePriceTokens],
  );
  return (
    <BuyTokensWidget
      appId={APP_ID}
      accountsUrl={accountsUrl}
      stripePublishableKey={stripePublishableKey}
      locale={locale}
      describeTokens={describeTokens}
      labels={{ tokensTitle: t("topUpTitle"), tokensDescription: t("topUpDescription") }}
    />
  );
}
